import React, { useRef } from 'react';
import { useState } from 'react';
import Switch from '@mui/material/Switch';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CachedIcon from '@mui/icons-material/Cached';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import MicIcon from '@mui/icons-material/Mic';
import SearchIcon from '@mui/icons-material/Search';
import { getSearchApi } from '../../../services/coAuthorService';
import Loader from '../../../utils/loader';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { useEffect } from 'react';
import { Button, IconButton } from '@material-ui/core';
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { getSearchHistory, deleteSearchSuggestion } from '../../../services/document';
import {Delete} from '@mui/icons-material';
import { option_ } from '../../Editor/utilize';
import HistoryIcon from '@mui/icons-material/History';
import { checkAIRequestLimit } from '../../aiRequestLimit';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import LinkIcon from '@mui/icons-material/Link';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'blue',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

export const CoAuthor_Searchcomponent = (props) => {
  const userDetails = useSelector((user) => user);
  const userID = props.trial ? props.userId : userDetails.user.currentUser._id;
  const email = sessionStorage.getItem("currentUserEmail");
  
  const [isAskActive, setIsAskActive] = useState(true);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [activeButton, setActiveButton] = useState("ask");
  const [showSerchTextValue, setSerchTextValue] = useState();
  const [showQuestiontextevalue, setQuestiontextValue] = useState();
  const [showSearchResponseContainer, setSearchResponseContainer] = useState(false);
  const [showSearchResponse, setSearchResponse] = useState({
    title: '',
    description: '',
    author: '',
    website: ''
  });
  const [showQuestionResponse, setQuestionResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authorName, setAuthorName] = useState();
  const [saveToNotesHovered, setSaveToNotesHovered] = useState({});
  const [copyIconHovered, setCopyIconHovered] = useState({});
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [micOutput, setmicOutput] = useState();
  const [isRecording, setIsRecording] = useState(false);
  const [searchHistoryForSearchOption, setSearchHistoryForSearchOption] = useState([]);
  const [searchHistoryForAskOption, setSearchHistoryForAskOption] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const inputRef = useRef(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [selectedWebsite, setSelectedWebsite] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(theme === 'true');
    };
    updateTheme();
    window.addEventListener('storage', updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDropdownChange = (event) => {
    setSelectedWebsite(event.target.value);
  };

  const handleButtonClick = () => {
    if (selectedWebsite) {
      const url = selectedWebsite.includes('https') ? selectedWebsite : `https://${selectedWebsite}`;
      window.open(url, "_blank");
    }
  };

  const handleSaveToNotesMouseEnter = (index) => {
    setSaveToNotesHovered(prevState => ({ ...prevState, [index]: true }));
  };

  const handleSaveToNotesMouseLeave = (index) => {
    setSaveToNotesHovered(prevState => ({ ...prevState, [index]: false }));
  };

  const handleCopyIconMouseEnter = (index) => {
    setCopyIconHovered(prevState => ({ ...prevState, [index]: true }));
  };

  const handleCopyIconMouseLeave = (index) => {
    setCopyIconHovered(prevState => ({ ...prevState, [index]: false }));
  };

  const handleCssClick = (button) => {
    if (button === 'ask') {
      setIsAskActive(true);
      setIsSearchActive(false);
      setActiveButton(button);
    } else if (button === 'search') {
      setIsSearchActive(true);
      setIsAskActive(false);
      setActiveButton(button);
    }
  };

  const handleSerchText = (e) => {
    let micValue = e.target.value;
    setmicOutput(micValue);
    resetTranscript();
  };

  const handleQuestionText = (e) => {
    setQuestiontextValue(e.target.value);
  };

  const handleQuestionApi = async () => {
    try {
      const checkailimit = await checkAIRequestLimit(userID);
      if (checkailimit === false) {
        toast.warn("AI request limit reached.");
        return;
      }
      if (!showQuestiontextevalue) {
        toast.warn("Please enter search term.");
        return;
      }
      setShowHistory(false);
      let data = {
        text: showQuestiontextevalue,
        type: "search",
        option: "askAQuestion",
        userId: userID,
        isCoAuthor: true
      };
      setLoading(true);
      const response = await getSearchApi(data);
      if (response) {
        setQuestionResponse(response.output);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSearchApi = async () => {
    try {
      const checkailimit = await checkAIRequestLimit(userID);
      if (checkailimit === false) {
        toast.warn("AI request limit reached.");
        return;
      }
      if (!micOutput) {
        toast.warn("Please enter search term.");
        return;
      }
      setShowHistory(false);
      let data = {
        text: `${micOutput}`,
        type: "search",
        option: "searchPrompt",
        userId: userID,
        isCoAuthor: true
      };

      setLoading(true);
      const response = await getSearchApi(data);
      if (response.output.length > 0) {
        const firstCorrection = response.output[0];
        const secondCorrection = JSON.parse(firstCorrection);
        const thirdCorrection = secondCorrection.replacements.corrections[0];
        const { Title, Description, Author } = thirdCorrection;
        const Website1 = response.url;
        
        setSearchResponse({
          title: Title,
          description: Description,
          author: Author,
          website: Website1
        });
        setSearchResponseContainer(true);
        setSerchTextValue();
        setLoading(false);
      } else {
        console.log("Invalid or missing data in the API response");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const citeAuthorName = () => {
    if (showSearchResponseContainer && showSearchResponse.author) {
      props.autherName(showSearchResponse.author);
    } else {
      toast.info('Author name not found');
    }
  };

  const handleCopyText = (text) => {
    let sentence = text;
    if (sentence === "") {
      toast.warn(`You don't have text to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        toast.info("Text copied!");
      },
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const handleAllCopyText = (textArray) => {
    const combinedText = textArray?.join('\n\n');
    navigator.clipboard.writeText(combinedText).then(
      function () {
        toast.info("All text has been copied!");
      },
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const saveToNotes = async (text) => {
    try {
      let sessionData = sessionStorage?.getItem('notesData') || "";
      sessionData = sessionData === "" ? text : `${sessionData}\n_______________________________________________________\n\n${text}`;
      sessionStorage.setItem('notesData', sessionData);
      toast.info(`Notes saved successfully.`);
    } catch (error) {
      console.log(error);
    }
  };

  const saveAllToNotes = async (textList) => {
    try {
      const combinedText = textList.join('\n\n');
      let sessionData = sessionStorage.getItem('notesData') || "";
      sessionData = sessionData === "" ? combinedText : `${sessionData}\n_______________________________________________________\n\n${combinedText}`;
      sessionStorage.setItem('notesData', sessionData);
      toast.info("All notes saved successfully.");
    } catch (error) {
      console.log(error);
    }
  };

  const copySearchResponse = () => {
    const { title, description, author, website } = showSearchResponse;
    const textToCopy = `Title: ${title}\nDescription: ${description}\nAuthor: ${author}\nWebsite: ${website}`;
    copyToClipboard(textToCopy);
  };

  const searchResponseSaveToNotes = async () => {
    const { title, description, author, website } = showSearchResponse;
    const websiteArray = Array.isArray(website) ? website : website.split(',');
    const formattedWebsites = websiteArray.map((url, index) => `\n\n ${index + 1}. ${url.trim()}`).join('');
    const textToSave = `_______________________________________________________\n\nTitle: ${title}\n\nDescription: ${description}\n\nAuthor: ${author}\n\nWebsite:${formattedWebsites}`;
    await saveToNotesForSearch(textToSave);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      function () {
        if (text) toast.info("Text copied!");
      },
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const saveToNotesForSearch = async (text) => {
    try {
      let sessionData = sessionStorage.getItem('notesData') || "";
      sessionData = sessionData === "" ? text : `${sessionData}\n\n${text}`;
      sessionStorage.setItem('notesData', sessionData);
      toast.info(`Notes saved successfully.`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMicClick = () => {
    if (SpeechRecognition.browserSupportsSpeechRecognition()) {
      if (isRecording) {
        SpeechRecognition.stopListening();
      } else {
        SpeechRecognition.startListening({ continuous: true });
      }
      setIsRecording(!isRecording);
    } else {
      toast.error("Speech recognition is not supported by your browser.");
    }
  };

  const handleTranscriptChange = () => {
    if (transcript) {
      setmicOutput(transcript);
    }
  };

  const fetchSearchHistory = async () => {
    const option = activeButton === 'ask' ? 'askAQuestion' : 'searchPrompt';
    let data = { option };
    try {
      const response = await getSearchHistory(data);
      if (option === 'askAQuestion') {
        setSearchHistoryForAskOption(response.data.askQuestionInputs);
      } else {
        setSearchHistoryForSearchOption(response.data.searchInputs);
      }
      setShowHistory(true);
    } catch (error) {
      console.error('Failed to fetch search history:', error);
    }
  };

  const handleSelectHistoryItem = (item) => {
    if (isSearchActive) {
      setmicOutput(item);
    }
    if (isAskActive) {
      setQuestiontextValue(item);
    }
    setShowHistory(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowHistory(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef]);

  const handleRemoveSearchHistory = async (searchString) => {
    try {
      let data;
      let updateFunction;
      if (isSearchActive) {
        data = {
          option: "searchPrompt",
          searchString
        };
        updateFunction = setSearchHistoryForSearchOption;
      }
      if (isAskActive) {
        data = {
          option: "askAQuestion",
          searchString
        };
        updateFunction = setSearchHistoryForAskOption;
      }
      const response = await deleteSearchSuggestion(data);
      updateFunction(prevHistory => prevHistory.filter(item => item !== searchString));
      toast.success("Search suggestion removed successfully.");
    } catch (error) {
      toast.error('Internal server error.');
    }
  };

  const handleMouseEnter = index => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  useEffect(() => {
    handleTranscriptChange();
  }, [transcript]);

  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: isDarkMode ? '#1a1a1a' : '#fff',
      // minHeight: '95vh'
    }}>
      <Loader loading={loading} />
      
      {/* Modern Tab Buttons */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '24px',
        borderRadius: '12px',
        padding: '4px',
        backgroundColor: isDarkMode ? '#2a2a2a' : '#f3f4f6',
        width: 'fit-content'
      }}>
        <button
          onClick={() => handleCssClick('ask')}
          style={{
            padding: '10px 24px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: activeButton === 'ask' ? (isDarkMode ? '#667eea' : '#667eea') : 'transparent',
            color: activeButton === 'ask' ? '#fff' : (isDarkMode ? '#9ca3af' : '#6b7280'),
            fontWeight: 600,
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            outline: 'none'
          }}
        >
          Ask a Question
        </button>
        <button
          onClick={() => handleCssClick('search')}
          style={{
            padding: '10px 24px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: activeButton === 'search' ? (isDarkMode ? '#667eea' : '#667eea') : 'transparent',
            color: activeButton === 'search' ? '#fff' : (isDarkMode ? '#9ca3af' : '#6b7280'),
            fontWeight: 600,
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            outline: 'none'
          }}
        >
          Search
        </button>
      </div>

      {/* Ask Question Section */}
      {isAskActive && (
        <div>
          <div style={{ position: "relative", marginBottom: '20px' }} ref={inputRef}>
            <input
              style={{
                width: '100%',
                padding: '14px 80px 14px 16px',
                borderRadius: '12px',
                border: `2px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
                color: isDarkMode ? '#fff' : '#111',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.3s ease',
                boxSizing: 'border-box'
              }}
              onChange={handleQuestionText}
              placeholder='Ask your question...'
              onFocus={fetchSearchHistory}
              value={showQuestiontextevalue}
            />
            
            {/* History Dropdown */}
            {showHistory && searchHistoryForAskOption.length > 0 && (
              <div style={{
                position: "absolute",
                width: "100%",
                top: "calc(100% + 4px)",
                left: 0,
                padding: "8px",
                zIndex: 1000,
                borderRadius: "12px",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {searchHistoryForAskOption.map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    padding: "10px 12px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: '8px',
                    marginBottom: '4px',
                    backgroundColor: hoverIndex === index ? (isDarkMode ? '#374151' : '#f3f4f6') : 'transparent',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}>
                    <div onClick={() => handleSelectHistoryItem(item)} style={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      gap: '8px',
                      flex: 1,
                      color: isDarkMode ? '#e5e7eb' : '#374151'
                    }}>
                      <HistoryIcon style={{ fontSize: "18px", color: '#9ca3af' }} />
                      <span style={{ fontSize: '14px' }}>{item}</span>
                    </div>
                    <LightTooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveSearchHistory(item)}
                        style={{ padding: '4px' }}
                      >
                        <Delete style={{ fontSize: "18px", color: "#ef4444" }} />
                      </IconButton>
                    </LightTooltip>
                  </div>
                ))}
              </div>
            )}
            
            {/* Clear Button */}
            {showQuestiontextevalue && (
              <IconButton
                onClick={() => setQuestiontextValue('')}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "50px",
                  transform: "translateY(-50%)",
                  padding: '6px',
                  backgroundColor: isDarkMode ? '#374151' : '#e5e7eb'
                }}
                size="small"
              >
                <CloseIcon style={{ fontSize: '18px', color: isDarkMode ? '#fff' : '#6b7280' }} />
              </IconButton>
            )}
            
            {/* Submit Button */}
            <IconButton
              onClick={handleQuestionApi}
              style={{
                position: "absolute",
                top: "50%",
                right: "12px",
                transform: "translateY(-50%)",
                padding: '8px',
                backgroundColor: '#667eea',
                color: '#fff'
              }}
              size="small"
            >
              <ArrowForwardIcon style={{ fontSize: '20px' }} />
            </IconButton>
          </div>

          {/* Question Response */}
          {showQuestionResponse && showQuestionResponse.length > 0 && (
            <div style={{ marginTop: '24px' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
                padding: '12px 16px',
                backgroundColor: isDarkMode ? '#2a2a2a' : '#f9fafb',
                borderRadius: '12px'
              }}>
                <Button
                  variant="text"
                  startIcon={<SaveAltIcon />}
                  onClick={() => saveAllToNotes(showQuestionResponse)}
                  style={{
                    color: isDarkMode ? '#fff' : '#111',
                    textTransform: 'none',
                    fontWeight: 600
                  }}
                >
                  Save All to Notes
                </Button>
                <LightTooltip title="Copy All">
                  <IconButton
                    onClick={() => handleAllCopyText(showQuestionResponse)}
                    style={{
                      backgroundColor: isDarkMode ? '#374151' : '#e5e7eb'
                    }}
                  >
                    <ContentCopyIcon style={{ fontSize: '20px', color: '#667eea' }} />
                  </IconButton>
                </LightTooltip>
              </div>

              {showQuestionResponse.map((data, index) => (
                <div key={index} style={{
                  padding: '16px',
                  marginBottom: '12px',
                  borderRadius: '12px',
                  backgroundColor: isDarkMode ? '#2a2a2a' : '#f9fafb',
                  border: `1px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`
                }}>
                  <p style={{
                    margin: '0 0 12px 0',
                    color: isDarkMode ? '#e5e7eb' : '#374151',
                    fontSize: '14px',
                    lineHeight: '1.6'
                  }}>{data}</p>
                  <div style={{ display: "flex", gap: '8px', justifyContent: 'flex-end' }}>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SaveAltIcon />}
                      onClick={() => saveToNotes(data)}
                      style={{
                        textTransform: 'none',
                        borderColor: isDarkMode ? '#374151' : '#e5e7eb',
                        color: isDarkMode ? '#fff' : '#111',
                        fontSize: '12px'
                      }}
                    >
                      Save
                    </Button>
                    <LightTooltip title="Copy">
                      <IconButton
                        size="small"
                        onClick={() => handleCopyText(data)}
                        style={{
                          backgroundColor: isDarkMode ? '#374151' : '#e5e7eb'
                        }}
                      >
                        <ContentCopyIcon style={{ fontSize: '16px', color: '#667eea' }} />
                      </IconButton>
                    </LightTooltip>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Search Section */}
      {isSearchActive && (
        <div>
          <div style={{ position: 'relative', marginBottom: '20px' }} ref={inputRef}>
            <input
              style={{
                width: '100%',
                padding: '14px 100px 14px 16px',
                borderRadius: '12px',
                border: `2px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
                color: isDarkMode ? '#fff' : '#111',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.3s ease',
                boxSizing: 'border-box'
              }}
              value={micOutput}
              onChange={handleSerchText}
              placeholder='Search anything or paste URL...'
              onFocus={fetchSearchHistory}
            />
            
            {/* History Dropdown for Search */}
            {showHistory && searchHistoryForSearchOption.length > 0 && (
              <div style={{
                position: "absolute",
                width: "100%",
                top: "calc(100% + 4px)",
                left: 0,
                padding: "8px",
                zIndex: 1000,
                borderRadius: "12px",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {searchHistoryForSearchOption.map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    padding: "10px 12px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: '8px',
                    marginBottom: '4px',
                    backgroundColor: hoverIndex === index ? (isDarkMode ? '#374151' : '#f3f4f6') : 'transparent',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}>
                    <div onClick={() => handleSelectHistoryItem(item)} style={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      gap: '8px',
                      flex: 1,
                      color: isDarkMode ? '#e5e7eb' : '#374151'
                    }}>
                      <HistoryIcon style={{ fontSize: "18px", color: '#9ca3af' }} />
                      <span style={{ fontSize: '14px' }}>{item}</span>
                    </div>
                    <LightTooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveSearchHistory(item)}
                        style={{ padding: '4px' }}
                      >
                        <Delete style={{ fontSize: "18px", color: "#ef4444" }} />
                      </IconButton>
                    </LightTooltip>
                  </div>
                ))}
              </div>
            )}

            {/* Clear Button */}
            {micOutput && (
              <IconButton
                onClick={() => setmicOutput('')}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "80px",
                  transform: "translateY(-50%)",
                  padding: '6px',
                  backgroundColor: isDarkMode ? '#374151' : '#e5e7eb'
                }}
                size="small"
              >
                <CloseIcon style={{ fontSize: '18px', color: isDarkMode ? '#fff' : '#6b7280' }} />
              </IconButton>
            )}

            {/* Mic Button */}
            <LightTooltip title={isRecording ? "Stop Recording" : "Start Recording"}>
              <IconButton
                onClick={handleMicClick}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  padding: '8px',
                  backgroundColor: isRecording ? '#ef4444' : (isDarkMode ? '#374151' : '#e5e7eb'),
                  color: isRecording ? '#fff' : (isDarkMode ? '#fff' : '#6b7280')
                }}
                size="small"
              >
                <MicIcon style={{ fontSize: '20px' }} />
              </IconButton>
            </LightTooltip>
          </div>

          {/* Search Button */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
            <button
              onClick={handleSearchApi}
              style={{
                padding: '12px 48px',
                backgroundColor: '#667eea',
                color: '#fff',
                border: 'none',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                outline: 'none'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#5568d3'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#667eea'}
            >
              Search
            </button>
          </div>

          {/* Search Results */}
          {showSearchResponseContainer && (
            <div style={{
              padding: '24px',
              borderRadius: '16px',
              backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
              border: `1px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            }}>
              {/* Title */}
              <h3 style={{
                fontSize: props.mobileView ? '16px' : '18px',
                fontWeight: 700,
                color: isDarkMode ? '#fff' : '#111',
                marginBottom: '12px',
                lineHeight: '1.4'
              }}>
                {showSearchResponse.title}
              </h3>

              {/* Description */}
              <p style={{
                fontSize: props.mobileView ? '13px' : '14px',
                color: isDarkMode ? '#d1d5db' : '#6b7280',
                lineHeight: '1.6',
                marginBottom: '16px'
              }}>
                {showSearchResponse.description}
              </p>

              {/* Author */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '20px',
                padding: '8px 12px',
                backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
                borderRadius: '8px',
                width: 'fit-content'
              }}>
                <span style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  color: isDarkMode ? '#9ca3af' : '#6b7280',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  Author:
                </span>
                <span style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: isDarkMode ? '#fff' : '#111'
                }}>
                  {showSearchResponse.author}
                </span>
              </div>

              {/* Website Dropdown and Explore */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px',
                flexWrap: props.mobileView ? 'wrap' : 'nowrap'
              }}>
                <select
                  onChange={handleDropdownChange}
                  value={selectedWebsite}
                  style={{
                    flex: 1,
                    minWidth: props.mobileView ? '100%' : '200px',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: `2px solid ${isDarkMode ? '#374151' : '#e5e7eb'}`,
                    backgroundColor: isDarkMode ? '#374151' : '#fff',
                    color: isDarkMode ? '#fff' : '#111',
                    fontSize: '14px',
                    cursor: 'pointer',
                    outline: 'none'
                  }}
                >
                  <option value="">Select a website</option>
                  {showSearchResponse.website.map((site, index) => (
                    <option key={index} value={site}>
                      {site}
                    </option>
                  ))}
                </select>

                <button
                  onClick={handleButtonClick}
                  disabled={!selectedWebsite}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: selectedWebsite ? '#667eea' : (isDarkMode ? '#374151' : '#e5e7eb'),
                    color: selectedWebsite ? '#fff' : (isDarkMode ? '#6b7280' : '#9ca3af'),
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: selectedWebsite ? 'pointer' : 'not-allowed',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedWebsite) e.target.style.backgroundColor = '#5568d3';
                  }}
                  onMouseLeave={(e) => {
                    if (selectedWebsite) e.target.style.backgroundColor = '#667eea';
                  }}
                >
                  <LinkIcon style={{ fontSize: '18px' }} />
                  Explore
                </button>
              </div>

              {/* Action Buttons */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: props.mobileView ? '1fr' : 'repeat(3, 1fr)',
                gap: '12px',
                marginTop: '20px'
              }}>
                <button
                  onClick={citeAuthorName}
                  style={{
                    padding: '12px 16px',
                    backgroundColor: isDarkMode ? '#374151' : '#fff',
                    color: isDarkMode ? '#fff' : '#111',
                    border: `2px solid ${isDarkMode ? '#4b5563' : '#e5e7eb'}`,
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.color = '#667eea';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = isDarkMode ? '#4b5563' : '#e5e7eb';
                    e.target.style.color = isDarkMode ? '#fff' : '#111';
                  }}
                >
                  <FormatQuoteIcon style={{ fontSize: '18px' }} />
                  Cite
                </button>

                <button
                  onClick={() => searchResponseSaveToNotes(showSearchResponse)}
                  style={{
                    padding: '12px 16px',
                    backgroundColor: isDarkMode ? '#374151' : '#fff',
                    color: isDarkMode ? '#fff' : '#111',
                    border: `2px solid ${isDarkMode ? '#4b5563' : '#e5e7eb'}`,
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#10b981';
                    e.target.style.color = '#10b981';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = isDarkMode ? '#4b5563' : '#e5e7eb';
                    e.target.style.color = isDarkMode ? '#fff' : '#111';
                  }}
                >
                  <SaveAltIcon style={{ fontSize: '18px' }} />
                  Save to Notes
                </button>

                <button
                  onClick={copySearchResponse}
                  style={{
                    padding: '12px 16px',
                    backgroundColor: isDarkMode ? '#374151' : '#fff',
                    color: isDarkMode ? '#fff' : '#111',
                    border: `2px solid ${isDarkMode ? '#4b5563' : '#e5e7eb'}`,
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#3b82f6';
                    e.target.style.color = '#3b82f6';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = isDarkMode ? '#4b5563' : '#e5e7eb';
                    e.target.style.color = isDarkMode ? '#fff' : '#111';
                  }}
                >
                  <ContentCopyIcon style={{ fontSize: '18px' }} />
                  Copy
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};